const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
          loading: "Processando, aguarde...",
        },
      },
      login: {
        title: "Bem-Vindo",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          loading: "Acessando o sistema aguarde...",
          register: "Não tem uma conta? Cadastre-se aqui!",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Mensagens Agendadas",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          sessionExpired: "Sua sessão expirou. Faça login novamente.",
          sessionReplaced: "Sua conta foi acessada em outro computador e esta sessão foi encerrada. Se não foi você, troque a senha.",
          invalidCredentials: "Credenciais de acesso inválidas. Verifique seus dados e tente novamente.",
          accessDenied: "Acesso negado. Fale com o administrador do sistema.",
          networkError: "Falha de conexão com o servidor. Verifique sua internet e tente novamente.",
          error: "Não foi possível fazer login. Tente novamente em instantes.",
        },
        token: "Token",
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Chats de hoje: ",
          },
        },
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão excluída com sucesso.",
          restarted: "Sessão reiniciada.",
          connectionTimedOut: "{{name}} está tentando conectar há muito tempo. Recomendamos reiniciar a sessão."
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
          restartTitle: "Reiniciar sessão",
          restartMessage: "Tem certeza que deseja reiniciar esta sessão? Isso encerrará a conexão atual e gerará um novo QR Code."
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR Code",
          newQr: "Novo QR Code",
          connecting: "Conectando",
          restart: "Reiniciar",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },                            
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          sendIdQueue: "Departamento",
          timeSendQueue: "Redirecionar para departamento em X minutos",
          queueRedirection: "Redirecionamento de Departamento",
          queueRedirectionDesc: "Selecione o departamento para onde vão os contatos que ainda não têm departamento",
          prompt: "Prompt",
          maxUseBotQueues: "Enviar bot x vezes",
          timeUseBotQueues: "Intervalo em minutos entre envio de bot",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os chats relacionados serão perdidos.",
          importMessage: "Deseja importar todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",   
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Departamento",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          whatsapp: "Conexão Origem: "
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar departamento",
          edit: "Editar departamento",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          ratingMessage: "Mensagem de avaliação",
          token: "Token",
          orderQueue: "Ordem do departamento",
          integrationId: "Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
		    attach: "Anexar Arquivo",
        },
        success: "Departamento salvo com sucesso.",
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Nova Mensagem Agendada",
          edit: "Editar Mensagem Agendada",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Etiqueta",
          edit: "Editar Etiqueta",
        },
        form: {
          name: "Nome",
          color: "Cor",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Etiqueta salva com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO",
          titleFileList: "Lista de arquivo(s)"
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Departamentos",
      },
      tickets: {
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Ativos" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para departamento",
        fieldQueuePlaceholder: "Selecione um departamento",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        buttons: {
          accept: "Aceitar",
          closed: "Encerrar",
          reopen: "Reabrir"
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      accountMenu: {
        trigger: "Opções da conta",
        admin: "Admin",
        user: "Atendente",
        profile: "Meu perfil",
        profileHint: "Nome, e-mail e senha",
        appearance: "Aparência",
        light: "Claro",
        dark: "Escuro",
        system: "Sistema",
        sounds: "Sons",
        volume: "Volume dos avisos",
        mute: "Silenciar",
        unmute: "Ativar som",
        test: "Testar",
        tickets: "Atendimentos",
        chat: "Chat interno",
        suggestion: "Sugerir melhoria",
        logout: "Sair",
        logoutTitle: "Sair do Message Express?",
        logoutText: "Você deixa de receber atendimentos neste navegador e aparece como offline para a equipe.",
        cancel: "Cancelar",
        online: "Online",
        away: "Ausente",
        goAway: "Ficar ausente",
        goOnline: "Ficar online",
        awayHint: "A equipe vê você como ausente. Você continua recebendo avisos.",
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Chats",
          quickMessages: "Respostas Rápidas",
          contacts: "Contatos",
          queues: "Departamentos",
          tags: "Etiquetas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Mensagens Agendadas",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          files: "Lista de arquivos",
          prompts: "Assistente IA",
          queueIntegration: "Integrações",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
          notRegister: "Nenhum chat registrado"
        },
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida dos departamentos e conexões vinculadas",
        },
      },
      files: {
        title: "Lista de arquivos",
        infoText: "Os arquivos carregados aqui só podem ser utilizados dentro do menu de Campanhas.",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Lista de Etiquetas",
            fileList: "Lista de Arquivos"
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
      announcements: {
        active: 'Ativo',
        inactive: 'Inativo',
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Departamentos",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
          orderQueue: "Ordenação",
        },
        buttons: {
          add: "Novo departamento",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Essa ação não pode ser desfeita. As conversas deste departamento continuam existindo, mas ficam sem departamento.",
        },
        errors: {
          delete: "Não foi possível excluir o departamento."
        },
      },
      queueSelect: {
        inputLabel: "Departamentos",
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para o departamento.",
        },
      },
      helps: {
        title: "Central de Ajuda",
      },
      schedules: {
        title: "Mensagens Agendadas",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta mensagem agendada?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Mensagem Agendada",
        },
        toasts: {
          deleted: "Mensagem agendada excluída com sucesso.",
        },
      },
      tags: {
        title: "Etiquetas",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Etiqueta?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Registros Etiquetados",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Etiqueta",
        },
        toasts: {
          deleted: "Etiqueta excluída com sucesso.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atendente:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem",
        placeholderClosed: "Ticket fechado. Não é possível enviar mensagens.",
        ticketClosedInfo: "Ticket fechado. Reabra para enviar mensagens.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      "campaignsMessageAlert": {
        "disclaimer": {
          "title": "Aviso Importante",
          "message": "O uso inadequado de campanhas pode levar ao bloqueio de sua conta pelo WhatsApp por violação das políticas anti-spam. Certifique-se de seguir todas as diretrizes antes de enviar mensagens em massa.",
          "responsibility": "A Message Express não se responsabiliza pelo bloqueio do número no WhatsApp decorrente do uso indevido ou abusivo das funcionalidades de campanha.",
          "agree": "Concordo"
        },
        "confirmationModal": {
          "deleteTitle": "Excluir campanha",
          "deleteMessage": "Esta ação não pode ser desfeita. Deseja realmente excluir esta campanha?"
        }
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        appointmentsModal: {
          title: "Observações do Contato",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket #",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OPPORTUNITY_FOUND: "Negócio não encontrado.",
        ERR_NO_PIPELINE_FOUND: "Funil não encontrado.",
        ERR_NO_STAGE_FOUND: "Etapa do funil não encontrada.",
        ERR_STAGE_NOT_IN_PIPELINE: "Esta etapa não pertence ao funil do negócio.",
        ERR_STAGE_HAS_OPPORTUNITIES:
          "Não é possível excluir uma etapa que ainda tem negócios. Mova os negócios para outra etapa antes.",
        ERR_PIPELINE_NEEDS_STAGES: "O funil precisa de pelo menos uma etapa.",
        ERR_PIPELINE_NEEDS_OPEN_STAGE:
          "O funil precisa de pelo menos uma etapa do tipo Aberto para receber novos negócios.",
        ERR_PIPELINE_INVALID_NAME: "Informe um nome para o funil.",
        ERR_LOST_REASON_REQUIRED: "Informe o motivo da perda.",
        ERR_OPPORTUNITY_INVALID_TITLE: "Informe o título do negócio.",
        ERR_LICENSE_EXPIRED:
          "Sua licença expirou. Acesse o Financeiro para regularizar o pagamento e reativar o sistema.",
        ERR_APPOINTMENT_NOT_FOUND: "Agendamento não encontrado.",
        ERR_INVALID_APPOINTMENT_STATUS: "Status de agendamento inválido.",
        ERR_INVALID_APPOINTMENT_STATUS_TRANSITION:
          "Esta mudança de status não é permitida. Agendamentos concluídos, com falta ou cancelados não podem ser revertidos.",
        ERR_SLOT_NOT_AVAILABLE: "Este horário não está mais disponível.",
        ERR_SERVICE_INVALID_USERS: "Um ou mais profissionais selecionados não pertencem a esta empresa.",
        ERR_LOGO_INVALID_TYPE: "Formato inválido. Use PNG, JPG ou WEBP.",
        ERR_LOGO_TOO_LARGE: "Imagem muito grande. Máximo de 2 MB.",
        ERR_INVALID_SLUG: "Link inválido. Use de 3 a 40 caracteres: letras, números e hífen.",
        ERR_SLUG_ALREADY_IN_USE: "Este link já está em uso por outra empresa.",
        ERR_TRANSACTION_NOT_FOUND: "Lançamento financeiro não encontrado.",
        ERR_INVALID_TRANSACTION_STATUS_TRANSITION:
          "Esta mudança de status não é permitida. Um lançamento pago não volta a pendente, e um lançamento cancelado não pode ser reaberto.",
        ERR_COMPANY_NAME_ALREADY_EXISTS: "Empresa já registrada.",
        ERR_COMPANY_INVALID_NAME: "Nome da empresa inválido.",
        ERR_EMAIL_ALREADY_EXISTS: "Este e-mail já está em uso.",
        ERR_INVALID_EMAIL: "E-mail inválido.",
        ERR_INVALID_PHONE: "Telefone inválido. Informe o número com DDD.",
        ERR_PHONE_ALREADY_EXISTS: "Este telefone já está cadastrado. Faça login ou fale com o suporte.",
        ERR_PASSWORD_TOO_WEAK:
          "A senha deve ter ao menos 6 caracteres.",
        ERR_INVALID_PLAN: "Plano selecionado inválido.",
        ERR_COMPANY_DISABLED:
          "Esta conta está desativada. Entre em contato com o suporte.",
        ERR_CANNOT_DELETE_OWN_COMPANY:
          "Não é possível excluir a própria empresa.",
        ERR_COMPANY_HAS_CROSS_REFERENCES:
          "Exclusão bloqueada: há dados de outra empresa ligados a esta. Veja o relatório de exclusão.",
        ERR_TOO_MANY_REQUESTS:
          "Muitas tentativas em pouco tempo. Aguarde um instante e tente novamente.",
        ERR_SUGGESTION_INVALID_FILE: "O print precisa ser uma imagem.",
        ERR_SUGGESTION_FILE_TOO_LARGE: "O print deve ter no máximo 5 MB.",
        ERR_CHAT_FILE_TOO_LARGE: "O arquivo deve ter no máximo 20 MB.",
        ERR_CHAT_INVALID_FILE: "Arquivo inválido.",
        ERR_NO_FILE_FOUND: "Lista de arquivos não encontrada.",
        ERR_FILE_LIST_IN_USE: "Esta lista está em uma campanha agendada ou em andamento. Troque a lista na campanha ou cancele a campanha antes de excluir.",
        ERR_FILE_LIST_NAME_ALREADY_EXISTS: "Já existe uma lista de arquivos com esse nome.",
        ERR_FILE_TOO_LARGE: "Cada arquivo deve ter no máximo 64 MB.",
        ERR_FILE_TYPE_NOT_ALLOWED: "Tipo de arquivo não reconhecido. Use imagem, vídeo, áudio, PDF ou documento.",
        ERR_CHAT_EMPTY_MESSAGE: "Escreva uma mensagem ou anexe um arquivo.",
        ERR_CHAT_TICKET_NOT_FOUND: "Atendimento não encontrado.",
        ERR_NO_CHAT_FOUND: "Conversa não encontrada.",
        ERR_NO_CHAT_MEDIA_FOUND: "Anexo não encontrado.",
        ERR_SUGGESTION_INVALID_STATUS: "Status de sugestão inválido.",
        ERR_ANNOUNCEMENT_INVALID_DATA: "Confira os campos do informativo (título até 120 e texto até 2000 caracteres).",
        ERR_ANNOUNCEMENT_INVALID_FILE: "A imagem precisa ser PNG, JPG ou WEBP.",
        ERR_ANNOUNCEMENT_FILE_TOO_LARGE: "A imagem deve ter no máximo 5 MB.",
        ERR_HELP_INVALID_DATA: "Confira o título (mínimo 3 letras) e o link do vídeo.",
        ERR_HELP_INVALID_VIDEO: "Link do YouTube inválido. Cole o link do vídeo ou o código de 11 caracteres.",
        ERR_NO_SUGGESTION_FOUND: "Sugestão não encontrada.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_SETTING_INVALID_KEY: "Configuração desconhecida.",
        ERR_SETTING_SECRET_MASKED:
          "Para trocar a chave, apague o campo inteiro e cole a nova.",
        ERR_SETTING_INVALID_VALUE: "Valor inválido para esta configuração.",
        ERR_SCHEDULES_INVALID:
          "Horários inválidos. Informe início e fim no formato HH:MM, com o fim depois do início.",
        ERR_PLAN_INVALID_NAME: "O nome do plano precisa ter de 2 a 60 caracteres.",
        ERR_PLAN_INVALID_LIMIT: "Usuários, conexões e departamentos precisam ser números inteiros.",
        ERR_PLAN_INVALID_VALUE: "Valor do plano inválido.",
        ERR_PLAN_INVALID_FLAG: "Recurso do plano inválido.",
        ERR_PLAN_NAME_ALREADY_EXISTS: "Já existe um plano com esse nome.",
        ERR_PLAN_IN_USE:
          "Este plano está em uso por empresas. Mude as empresas para outro plano antes de excluir.",
        ERR_NO_DIALOG_FOUND: "Integração não encontrada.",
        ERR_PLAN_FEATURE_DISABLED: "O plano da sua empresa não inclui este recurso.",
        ERR_BLOCK_NOT_FOUND: "Bloqueio não encontrado.",
        ERR_BLOCK_INVALID_TIME_RANGE: "O horário de início deve ser menor que o de término.",
        ERR_BLOCK_INVALID_DATE_RANGE: "A data final não pode ser anterior à inicial.",
        ERR_BLOCK_RANGE_TOO_LONG: "O período do bloqueio pode ter no máximo 90 dias.",
        ERR_NO_TAG_FOUND: "Nenhuma etiqueta encontrada com este ID.",
        ERR_NO_CAMPAIGN_FOUND: "Campanha não encontrada.",
        ERR_NO_COMPANY_FOUND: "Empresa não encontrada.",
        ERR_NO_TAGS_TO_ORDER: "Nenhuma etiqueta do Kanban foi enviada para ordenação.",
        ERR_INVALID_TAG_ORDER: "A ordem enviada para as raias do Kanban é inválida.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_INVALID_DATE: "Data inválida. Use uma data real no formato dia/mês/ano.",
        ERR_CONTACT_FIELDS_INVALID: "Lista de campos inválida.",
        ERR_CONTACT_FIELDS_TOO_MANY: "No máximo 30 campos na ficha.",
        ERR_CONTACT_FIELD_NAME_INVALID: "Cada campo precisa de um nome (até 100 caracteres).",
        ERR_CONTACT_FIELD_DUPLICATED: "Há dois campos com o mesmo nome.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhatsApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatória quando há mais de um departamento.",
      },
    },
  },
};

export { messages };